var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 19.9375L4.2625 21.6559L13.75 12.4178V34.5625H16.25V12.4178L25.7375 21.6559L27.5 19.9375L15 7.75L2.5 19.9375ZM2.5 7.75V2.875H27.5V7.75H30V2.875C30 2.22853 29.7366 1.60855 29.2678 1.15143C28.7989 0.694307 28.163 0.4375 27.5 0.4375H2.5C1.83696 0.4375 1.20107 0.694307 0.732233 1.15143C0.263392 1.60855 0 2.22853 0 2.875V7.75H2.5Z",
    fill: "#C10037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService6);
export default __webpack_public_path__ + "static/media/service-6.320baabe5fa7a3cc65093ab859955ea9.svg";
export { ForwardRef as ReactComponent };